import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ScrollToTop } from './components/shared/ScrollToTop'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { createErrorHandler } from './lib/error-reporting'
import { SignInPage } from './modules/auth/SignInPage'
import { SignUpPage } from './modules/auth/SignUpPage'
import { ProtectedRoute } from './components/shared/ProtectedRoute'
import { DashboardLayout } from './layouts/DashboardLayout'
import { DashboardPage } from './modules/crawl/pages/DashboardPage'
import { CrawlListPage } from './modules/crawl/pages/CrawlListPage'
import { NewCrawlPage } from './modules/crawl/pages/NewCrawlPage'
import { CrawlDetailPage } from './modules/crawl/pages/CrawlDetailPage'
import { SitesPage } from './modules/crawl/pages/SitesPage'
import { SiteDetailPage } from './modules/site/pages/SiteDetailPage'
import { IntegrationsPage } from './modules/crawl/pages/IntegrationsPage'
import { ReportPage } from './modules/report/ReportPage'
import { AlertSettingsPage } from './modules/site/pages/AlertSettingsPage'

function App() {
  return (
    <ErrorBoundary onError={createErrorHandler()}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public report (no auth required) */}
          <Route path="/reports/:token" element={<ReportPage />} />

          {/* Auth */}
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />

          {/* Protected dashboard routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="crawls" element={<CrawlListPage />} />
            <Route path="crawls/new" element={<NewCrawlPage />} />
            <Route path="crawls/:id" element={<CrawlDetailPage />} />
            <Route path="sites" element={<SitesPage />} />
            <Route path="sites/:siteId" element={<SiteDetailPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="alert-settings" element={<AlertSettingsPage />} />
          </Route>

          {/* Redirect root to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
